export default __webpack_public_path__ + "static/media/image-gallery-orange.49f4212b.jpg";